import { z } from 'zod';

export type RoleType = 'Leader' | 'Manager';

const ManagerSchema = z.object({
  id: z.string(),
  email: z.string(),
  displayName: z.string(),
});

const GroovUserDTOSchema = z.object({
  id: z.string(),
  integrationId: z.string(),
  displayName: z.string(),
  email: z.string(),
  manager: ManagerSchema.nullable().optional(),
});

const UserRoleSchema = z.object({
  id: z.string(),
});

const UserRolesDTOSchema = z.object({
  userId: z.string(),
  roles: z.array(UserRoleSchema),
});

const GroovUserSchema = GroovUserDTOSchema.extend({
  roles: UserRoleSchema.array(),
});

export type Manager = z.infer<typeof ManagerSchema>;

export type Role = z.infer<typeof UserRoleSchema>;

export type GroovUser = z.infer<typeof GroovUserSchema>;

export const Schemas = {
  GroovUserDTOSchema,
  UserRolesDTOSchema,
  GroovUserSchema,
};
